import { useTranslation } from "react-i18next";

import { useApp } from "context/app";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import NewProjectContent from "page_components/client/new-project/Content";

const NewProject = () => {
  const { t } = useTranslation();
  const { websites } = useApp();

  const actions = [
    {
      label: t("Add new website"),
      href: "/websites/new",
      event: () =>
        window.gtag("event", "new_website", {
          click_text: t("Add new website"),
          click_url: `/websites/new`,
        }),
    },
    ...(websites?.length > 0
      ? [
          {
            type: "create_client_task",
            onboarding_button: true,
          },
        ]
      : []),
  ];

  return (
    <DashboardContentLayout
      header={{
        label: t("Need a new project?"),
        description: t(
          "We offer a wide range of services in website and online store design and enhancement."
        ),
      }}
      actions={actions}
    >
      <NewProjectContent />
    </DashboardContentLayout>
  );
};

export default NewProject;
